import { reviewDimensions, topRated } from "@/mocks/platforms";

export default function ReviewSection() {
  return (
    <section id="review" className="bg-background-900 py-16 md:py-24">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-label tracking-[0.2em] text-accent-400 uppercase">Reputation</span>
          <h2 className="mt-3 font-heading font-bold text-background-50 text-2xl md:text-4xl">口碑榜与评分怎么来的</h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-background-300">
            排行不是拍脑袋。我们把「好不好用」拆成四个可量化的维度，公布权重和口径，让每一名的升降都有据可查。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <div className="lg:col-span-7 space-y-3">
            {reviewDimensions.map((dim) => (
              <div
                key={dim.id}
                className="flex items-start gap-4 rounded-lg bg-background-800/60 border border-background-700 p-4 md:p-5"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-500 text-background-900 shrink-0">
                  <i className={`${dim.icon} text-xl`}></i>
                </span>
                <div className="flex-1">
                  <div className="flex items-center justify-between gap-3">
                    <h3 className="font-heading font-semibold text-base text-background-50">{dim.name}</h3>
                    <span className="px-2.5 py-0.5 text-xs rounded-full bg-background-700 text-accent-300 whitespace-nowrap">
                      权重 {dim.weight}
                    </span>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-background-300">{dim.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-lg bg-background-50 p-5 md:p-6 h-full">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-medal-line"></i>
                </span>
                <h3 className="font-heading font-bold text-lg text-foreground-950">口碑优选榜</h3>
              </div>
              <p className="mt-3 text-sm text-foreground-600">
                由长期评分与回访反馈筛出的少数几家，稳定性和阅读体验优先。
              </p>

              <div className="mt-5 divide-y divide-background-200">
                {topRated.map((item) => (
                  <div key={item.id} className="py-4 first:pt-0 last:pb-0">
                    <div className="flex items-center justify-between gap-3">
                      <div className="flex items-center gap-2.5">
                        <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                          <i className={item.icon}></i>
                        </span>
                        <span className="font-heading font-semibold text-foreground-950">{item.name}</span>
                      </div>
                      <span className="inline-flex items-center gap-1 text-sm font-bold text-primary-600 whitespace-nowrap">
                        <i className="ri-star-fill text-accent-500"></i>
                        {item.score}
                      </span>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.reason}</p>
                  </div>
                ))}
              </div>

              <a
                href="#rank"
                className="mt-5 flex items-center justify-center gap-2 w-full py-3 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                回到完整榜单
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}